module.exports = __webpack_public_path__ + "static/img/0001吉林市人民政府.d77bd24.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/0001吉林市人民政府.jpg
// module id = N9HY
// module chunks = 0